import { render, staticRenderFns } from "./EpsAttachmentCategories.vue?vue&type=template&id=7dddd4b4&"
import script from "./EpsAttachmentCategories.vue?vue&type=script&lang=js&"
export * from "./EpsAttachmentCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports